export const TOKEN_NAME = 'access_token';



// WEBPACK FOOTER //
// ./src/app/services/auth.constant.ts